// @tennis-matches/core/utils
// Framework-/UI-freie Match-/Ergebnislogik (Web + Mobile).
// Migrated from packages/core/src/matchResult.js

export function normalizeResultRules(rr) {
  const mode = rr?.mode || "TWO_SETS_MTB";
  return {
    mode, // "ONE_SET_OPEN" | "TWO_SETS_MTB" | "BEST_OF_3_FULL"
    gamesToWinSet: numOr(rr?.gamesToWinSet, 6),
    openSetWinByGames: numOr(rr?.openSetWinByGames, 2),
    setWinByGames: numOr(rr?.setWinByGames, 2),
    mtbPointsToWin: numOr(rr?.mtbPointsToWin, 10),
    mtbWinByPoints: numOr(rr?.mtbWinByPoints, 2),
  };
}

export function normalizeSets(sets) {
  const s = Array.isArray(sets) ? sets : [];
  const get = (i) => ({ a: s[i]?.a ?? "", b: s[i]?.b ?? "" });
  return [get(0), get(1), get(2)];
}

/**
 * outcomeFromSets
 * - Für ONE_SET_OPEN: wenn roundIsClosed = true, dann entscheidet höhere Zahl (auch wenn < Ziel)
 * - Sonst: klassisch nach Regeln
 */
export function outcomeFromSets(sets, rr, { roundIsClosed = false } = {}) {
  if (!Array.isArray(sets)) return "";

  if (rr.mode === "ONE_SET_OPEN") {
    const a = toNumOrNull(sets?.[0]?.a);
    const b = toNumOrNull(sets?.[0]?.b);
    if (a == null || b == null) return "";

    if (roundIsClosed) {
      if (a > b) return "A";
      if (b > a) return "B";
      return "D";
    }

    return winnerOfSetGames(sets[0], rr.gamesToWinSet, rr.openSetWinByGames);
  }

  if (rr.mode === "TWO_SETS_MTB") {
    const w1 = winnerOfSetGames(sets[0], rr.gamesToWinSet, rr.setWinByGames);
    const w2 = winnerOfSetGames(sets[1], rr.gamesToWinSet, rr.setWinByGames);
    if (!w1 || !w2) return "";

    const winsA = (w1 === "A") + (w2 === "A");
    const winsB = (w1 === "B") + (w2 === "B");
    if (winsA === 2) return "A";
    if (winsB === 2) return "B";

    return winnerOfSetPoints(sets[2], rr.mtbPointsToWin, rr.mtbWinByPoints);
  }

  // BEST_OF_3_FULL
  const w1 = winnerOfSetGames(sets[0], rr.gamesToWinSet, rr.setWinByGames);
  const w2 = winnerOfSetGames(sets[1], rr.gamesToWinSet, rr.setWinByGames);
  const w3 = winnerOfSetGames(sets[2], rr.gamesToWinSet, rr.setWinByGames);

  let winsA = 0, winsB = 0;
  for (const w of [w1, w2, w3]) {
    if (w === "A") winsA++;
    if (w === "B") winsB++;
  }
  if (winsA >= 2) return "A";
  if (winsB >= 2) return "B";
  return "";
}

export function sumGames(sets) {
  const arr = Array.isArray(sets) ? sets : [];
  let aGames = 0;
  let bGames = 0;
  for (const set of arr) {
    const a = toNumOrNull(set?.a);
    const b = toNumOrNull(set?.b);
    if (a == null || b == null) continue;
    aGames += a;
    bGames += b;
  }
  return { aGames, bGames };
}

/* -------------------------
   internal helpers
------------------------- */

function winnerOfSetGames(set, target, winBy) {
  const a = toNumOrNull(set?.a);
  const b = toNumOrNull(set?.b);
  if (a == null || b == null) return "";
  if (isWon(a, b, target, winBy)) return "A";
  if (isWon(b, a, target, winBy)) return "B";
  return "";
}

function winnerOfSetPoints(set, target, winBy) {
  const a = toNumOrNull(set?.a);
  const b = toNumOrNull(set?.b);
  if (a == null || b == null) return "";
  if (isWon(a, b, target, winBy)) return "A";
  if (isWon(b, a, target, winBy)) return "B";
  return "";
}

function isWon(a, b, target, winBy) {
  if (a < target && b < target) return false;
  return a >= target && (a - b) >= winBy;
}

function toNumOrNull(v) {
  if (v === "" || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function numOr(v, fallback) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

